import Icon from '../components/Icon';

const PlaceMountain = Icon(
  'place-mountain',
  <>
    <path
      fillRule="evenodd"
      d="M14.049 3.267c.565-1.573 2.804-1.534 3.314.058l5.142 16.043A1.25 1.25 0 0 1 21.315 21H2.705a1.25 1.25 0 0 1-1.18-1.665l3.888-11.08c.534-1.523 2.67-1.572 3.274-.076l1.904 4.718zm1.886.516a.25.25 0 0 0-.474-.009L9.816 19.5h11.156zM7.297 8.74a.25.25 0 0 0-.468.011L3.059 19.5H8.23q.024-.087.054-.172l1.546-4.31z"
      clipRule="evenodd"
    />
  </>
);

export default PlaceMountain;
